<template lang="pug">

  MDashboardWidget( title="Audits selected by BatchId" )

    div(class="form-group row")

        div(class="col-sm-10")
          label Batch Id
          p It is possible to submit multiple batch IDs separated by commas eg: "batch1,batch2,batch3"
          input(type="text" placeholder="Enter Batch ID" class="form-control" v-model="generateBatchId") 

        div(class="col-sm-12 mt-3")
          button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="! generateBatchId || loading" v-on:click="generateCSV('publisher')" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Publisher Report
          button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="! generateBatchId || loading" v-on:click="generateCSV('debug')" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Debug Report
          button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="! generateBatchId || loading" v-on:click="generateCSV('debug-without-superseded')" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Debug Without Superseded
          button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="! generateBatchId || loading" v-on:click="generateCSV('full')" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Multi Line Report
          button( class="btn btn-details btn-outline btn-info mr-2 mt-2" v-bind:disabled="! generateBatchId || loading" v-on:click="generateCSV('newPublisher')" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Playground Publisher Report
          button( class="btn btn-details btn-outline btn-info mr-2 mt-2" v-bind:disabled="! generateBatchId || loading" v-on:click="generateCSV('newNetwork')" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Playground Network Report

          p( class="text-danger m-0" v-if="errorMessage" ) {{ errorMessage }}
    
</template>
<style lang="scss" scoped></style>

<script>
import gql from "graphql-tag";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      generateBatchId: "",
      loading: false,
      errorMessage: "",
    };
  },
  methods: {
    myMethod() {
      console.log("do something");
    },

    async generateCSV(type) {
      this.loading = true;

      const {
        data: { generateClientReport },
      } = await this.$apollo.query({
        query: gql`
          query generateClientReport($batchIds: [ID!]!, $type: String!) {
            generateClientReport(batchIds: $batchIds, type: $type)
          }
        `,
        variables: {
          batchIds: this.generateBatchId.split(","),
          type,
        },
      });

      const a = document.createElement("a");
      document.body.appendChild(a);
      a.setAttribute("style", "display:none");
      const blob = new Blob([generateClientReport], { type: "octet/stream" });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = `batches_.csv`;
      a.click();
      window.URL.revokeObjectURL(url);

      this.loading = false;
    },
  },
});
</script>
